import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcTwotoneMoneyOffCsred = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M18.75 10.35c2.67 0 3.66 1.275 3.75 3.15h3.315c-.105-2.58-1.68-4.95-4.815-5.715V4.5h-4.5v3.24a8.5 8.5 0 0 0-1.65.54l2.265 2.265a6.8 6.8 0 0 1 1.635-.195M8.205 5.88 6.09 7.995l5.16 5.16c0 3.12 2.34 4.83 5.865 5.865l5.265 5.265c-.51.735-1.575 1.365-3.63 1.365-3.09 0-4.305-1.38-4.47-3.15h-3.3c.18 3.285 2.64 5.13 5.52 5.745V31.5H21v-3.225c1.44-.27 2.745-.825 3.69-1.68l3.33 3.33 2.115-2.115z"
	})
});
export default SvgIcTwotoneMoneyOffCsred;
